import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: ', ';\n'], ['\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  outline: none;\n  box-shadow: 0 0 0 2px ', ';\n'], ['\n  outline: none;\n  box-shadow: 0 0 0 2px ', ';\n']);

import { css } from 'styled-components';


export var truncate = function truncate() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  return css(_templateObject, width);
};

export var focusOutline = function focusOutline(color) {
  return css(_templateObject2, color || '');
};